import styled, { css } from "styled-components"
import { SubTitle } from "componentsStyled/Typography/Titles"

export const SubGroupWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 2rem;
  margin-bottom: 1rem;
  ${p =>
    p.isOpened &&
    css`
      border-bottom: 0.1rem solid ${(props) => props.theme.color.newLight};
    `}

  ${p =>
    p.center &&
    css`
      justify-content: center;
    `}
  &:hover {
    cursor: pointer;
  }
`

export const CollapsiblePanelTitle = styled(SubTitle)`
  text-align: center;
  line-height: 1;
`



// WEBPACK FOOTER //
// ./src/components/CollapsiblePanel/styled.js